export default __webpack_public_path__ + "static/media/back_arrow.3fa3146d.svg";